import { render, staticRenderFns } from "./LeaderboardShort.vue?vue&type=template&id=73f8e426&scoped=true"
import script from "./LeaderboardShort.vue?vue&type=script&lang=js"
export * from "./LeaderboardShort.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardShort.vue?vue&type=style&index=0&id=73f8e426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f8e426",
  null
  
)

export default component.exports